import React from "react";
import { Minus, Plus } from "lucide-react";

const QuantityStepper = ({ value, onChange, min = 1, max = 99, size = "sm", testId = "qty" }) => {
    const h = size === "lg" ? "h-12" : "h-8";
    const w = size === "lg" ? "w-12" : "w-8";
    const set = (n) => onChange(Math.min(max, Math.max(min, n)));
    return (
        <div
            className={`inline-flex items-center rounded-full border border-primary/30 bg-white/80 backdrop-blur ${h} overflow-hidden`}
            data-testid={`${testId}-stepper`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
        >
            <button type="button" onClick={() => set(value - 1)} disabled={value <= min} aria-label="Decrease quantity" data-testid={`${testId}-minus`}
                className={`${w} ${h} flex items-center justify-center text-primary hover:bg-primary/10 disabled:opacity-30 transition-colors`}>
                <Minus className="w-3.5 h-3.5" />
            </button>
            <input
                type="number"
                min={min}
                max={max}
                value={value}
                onChange={(e) => set(parseInt(e.target.value || min, 10))}
                aria-label="Quantity"
                data-testid={`${testId}-input`}
                className={`${size === "lg" ? "w-12 text-base" : "w-8 text-sm"} text-center font-semibold bg-transparent outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none`}
            />
            <button type="button" onClick={() => set(value + 1)} disabled={value >= max} aria-label="Increase quantity" data-testid={`${testId}-plus`}
                className={`${w} ${h} flex items-center justify-center text-primary hover:bg-primary/10 disabled:opacity-30 transition-colors`}>
                <Plus className="w-3.5 h-3.5" />
            </button>
        </div>
    );
};

export default QuantityStepper;
